import { useNavigate } from "react-router-dom";
import { Upload } from "lucide-react";
import { MEDIA, whatsappLink, DEFAULT_WA_MESSAGE } from "@/lib/config";

const WhatsAppIcon = ({ className }) => (
    <svg viewBox="0 0 32 32" className={className} fill="currentColor" aria-hidden="true">
        <path d="M16.004 0h-.008C7.174 0 .002 7.174.002 16c0 3.5 1.13 6.747 3.05 9.38L1.06 31.27l6.067-1.94A15.9 15.9 0 0 0 16.004 32C24.83 32 32 24.826 32 16S24.83 0 16.004 0zm9.31 22.594c-.386 1.09-1.92 1.995-3.144 2.26-.836.178-1.928.32-5.604-1.204-4.7-1.948-7.726-6.724-7.962-7.034-.226-.31-1.9-2.53-1.9-4.826 0-2.296 1.166-3.424 1.636-3.904.386-.396.844-.576 1.126-.576.366 0 .67.004.936.018.3.014.7-.114 1.094.834.404.972 1.374 3.36 1.494 3.604.122.244.204.53.04.84-.154.31-.232.502-.46.772-.232.27-.484.602-.69.808-.232.23-.474.48-.204.94.27.46 1.2 1.98 2.578 3.208 1.77 1.578 3.262 2.066 3.722 2.296.46.232.728.194.996-.116.27-.31 1.15-1.342 1.456-1.804.302-.46.61-.384 1.026-.23.42.154 2.658 1.252 3.116 1.48.46.232.764.346.876.538.116.192.116 1.108-.27 2.176z" />
    </svg>
);

export const FinalCTA = () => {
    const navigate = useNavigate();
    return (
        <section className="relative overflow-hidden border-t border-border bg-[#0A0A0A] py-24">
            <div className="absolute inset-0">
                <img src={MEDIA.abstract} alt="" className="h-full w-full object-cover opacity-25" />
                <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A] via-[#0A0A0A]/85 to-[#0A0A0A]" />
            </div>

            <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8">
                <h2 className="font-heading text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-6xl">
                    Bereit für <span className="text-gradient-red">mehr Leistung?</span>
                </h2>
                <p className="mx-auto mt-5 max-w-2xl text-base text-[#A1A1AA] sm:text-lg">
                    Lade jetzt deinen Zulassungsschein hoch und erhalte deine kostenlose KI-Analyse in
                    Sekunden. Unverbindlich und transparent.
                </p>

                <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
                    <button
                        data-testid="final-cta-upload"
                        onClick={() => navigate("/analyse")}
                        className="inline-flex w-full items-center justify-center gap-2.5 rounded-md bg-primary px-7 py-4 text-base font-bold text-white red-glow hover:bg-[#FF3B30] transition-colors sm:w-auto"
                    >
                        <Upload className="h-5 w-5" />
                        Kostenlos analysieren
                    </button>
                    <a
                        data-testid="final-cta-whatsapp"
                        href={whatsappLink(DEFAULT_WA_MESSAGE)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex w-full items-center justify-center gap-2.5 rounded-md border border-[#25D366]/40 bg-[#25D366]/10 px-7 py-4 text-base font-semibold text-white hover:bg-[#25D366]/20 transition-colors sm:w-auto"
                    >
                        <WhatsAppIcon className="h-5 w-5 text-[#25D366]" />
                        Per WhatsApp anfragen
                    </a>
                </div>
            </div>
        </section>
    );
};

export default FinalCTA;
